import React, { useEffect, useState, useContext } from 'react';
import { FormControl, InputLabel, makeStyles, MenuItem, Select } from '@material-ui/core';
import { commonFilter, NoneArrow } from '../constants/StyleConstants';
import { InventoriesContext } from '../contexts/InventoriesContext';

const useStyles = makeStyles(theme => ({
  ...commonFilter,
  formControl: props => ({
    minWidth: 120,
    width: props.variableWidth ? props.variableWidth : 300,
  }),
  selectWrapper: {
    marginTop: 8,
    marginBottom: 4,
  },
}));

const RegionSelect = ({ value, setValue, title = 'Region', matchById, readOnly, variableWidth }) => {
  const [options, setOptions] = useState([]);
  const classes = useStyles({ variableWidth: variableWidth === true ? 'fit-content' : variableWidth });
  const { getTheRegions } = useContext(InventoriesContext);

  useEffect(() => {
    getTheRegions().then(res => setOptions(res));
  }, []);

  return (
    <div className={classes.selectWrapper}>
      <FormControl className={classes.formControl}>
        <InputLabel id="select-state-label">{title}</InputLabel>
        <Select
          IconComponent={readOnly ? NoneArrow : undefined}
          margin="dense"
          labelId="select-state-label"
          id="state-select"
          inputProps={{ readOnly: readOnly }}
          value={value}
          onChange={e => setValue(e.target.value)}>
          {options &&
            options.map((region, index) => (
              <MenuItem key={index} value={matchById ? region.id : region}>
                {region.name.toTitleCase()}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default RegionSelect;
